import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { ModuleAddEditComponent, ModuleListComponent } from '@user/components/module';

const routes: Routes = [
  { path: 'list', component: ModuleListComponent, data: { title: 'Modules' } },
];
@NgModule({
  declarations: [ModuleAddEditComponent, ModuleListComponent],
  imports: [
    RouterModule.forChild(routes),
    MaterialModule,
    SharedModule
  ],
  entryComponents: [ModuleAddEditComponent]
})
export class ModuleBasedModule { }
